import React, { useRef } from "react";
import Navbar from "../components/Navbar"; // Import your Navbar
import "../styles/Contact_us.css";
import { Player } from "@lottiefiles/react-lottie-player";
import emailjs from "emailjs-com";

const ContactUs = () => {
  const formRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "ecx_website",
        "contact_us",
        formRef.current,
        "uGkudy91r59Cvszmj"         // Replace with your EmailJS user/public key
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Message sent successfully!");
        },
        (error) => {
          console.log(error.text);
          alert("Failed to send message, please try again.");
        }
      );

    // Optionally reset the form after sending
    e.target.reset();
  };

  return (
    <>
      <Navbar /> {/* Include Navbar component here */}
      <div className="contact-container">
        <div className="background-animation">
          <Player
            autoplay
            loop
            src="https://assets2.lottiefiles.com/packages/lf20_vfscj7iq.json"
            background="transparent"
            speed={1}
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: -1,
            }}
          />
        </div>
        <div className="contact-card">
          <div className="contact-left">
            <h2>Contact Us</h2>
            <form ref={formRef} onSubmit={sendEmail}>
              <input
                type="text"
                name="user_name"
                placeholder="Your Name"
                pattern="[A-Za-z ]{2,}"
                title="Please enter a valid name"
                required
              />
              <input
                type="email"
                name="user_email"
                placeholder="Your Email"
                pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
                title="Please enter a valid email address"
                required
              />
              <input
                type="tel"
                name="user_phone"
                placeholder="Your Phone Number"
                pattern="\d{10}"
                title="Please enter a valid 10-digit phone number"
                required
              />
              <textarea
                name="message"
                placeholder="Your Message"
                required
              ></textarea>
              <button type="submit" className="btn-hover">
                Send Message
              </button>
            </form>
          </div>
          <div className="contact-right">
            <Player
              autoplay
              loop
              src="https://assets2.lottiefiles.com/packages/lf20_jcikwtux.json"
              background="transparent"
              speed={1}
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </div>
        <div className="contact-details">
          <div className="detail-item">
            <img
              src="https://cdn-icons-png.flaticon.com/512/684/684908.png"
              alt="Address"
            />
            <p>Cuttack, Odisha, 753002</p>
          </div>
          <div className="detail-item">
            <img
              src="https://cdn-icons-png.flaticon.com/512/455/455705.png"
              alt="Phone"
            />
            <p>+91 6001 563 923</p>
          </div>
          <div className="detail-item">
            <img
              src="https://cdn-icons-png.flaticon.com/512/732/732200.png"
              alt="Email"
            />
            <p>
              <a href="mailto:contact@encryptarx.in">contact@encryptarx.in</a>
            </p>
          </div>
        </div>
        <div className="social-icons">
          <button className="icon facebook" onClick={() => window.open('https://www.facebook.com', '_blank')}>
            <img
              src="https://cdn-icons-png.flaticon.com/512/733/733547.png"
              alt="Facebook"
            />
          </button>
          <button className="icon twitter" onClick={() => window.open('https://www.twitter.com', '_blank')}>
            <img
              src="https://cdn-icons-png.flaticon.com/512/733/733579.png"
              alt="Twitter"
            />
          </button>
          <button className="icon linkedin" onClick={() => window.open('https://www.linkedin.com', '_blank')}>
            <img
              src="https://cdn-icons-png.flaticon.com/512/145/145807.png"
              alt="LinkedIn"
            />
          </button>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
